import {useState, useEffect, useMemo} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Routes, Route, Outlet, Navigate, useLocation, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../../../../_metronic/layout/core'
import DeleteConfirmationPopup from '../../../../../Components/DeleteConfirmationPopup'
import {GetAllComment, UserIdForComment} from '../../../../../Redux/AdminPanel/CommentSlice'
import {QuickMsg} from '../../../../../Redux/AdminPanel/QuickMessageSlice'
import {DeleteStaffAccount, UpdateStatusStaff} from '../StaffAccountSlice/StaffAccountSlice'

import AssignUser from './AssignUser'
import Credits from './Credits'
import CreateNotification from './modal/CreateNotification'
import More from './More'
import Overview from './Overview'
import StaffProfile from './StaffProfile'
import QuickMessageDrawerInner from '../../../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import {AuthenticateUser} from '../../../../../Utils/_helpers/RoleAndPermission'
import {GeneralDataOFLoginUser} from '../../../../../Utils/Auth'
import Commision from './Commision'
import { resetRedux } from '../../../../../Redux/store'
import { adminLoginAsStaff } from '../../../../../Redux/AdminPanel/AdminAuthSlice'

const StaffProfileDetails = () => {
  const isUserWhiteLabel = GeneralDataOFLoginUser()?.isWhiteLabelUser === true
  const param: any = useLocation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  //////////////////////////////////USESTATE HOOK///////////////////////////////////////////////
  const [data, setData] = useState<any>({})
  const [notify, setNotify] = useState(false)
  const [deletePopup, setDeletePopup] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const [userId, setUserId] = useState<any>('')
  const [quickMessagePopup, setQuickMessagePopup] = useState(false)

  const ProfileDetatileState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)

  //////////////////////////////////USESTATE HOOK///////////////////////////////////////////////

  ////////////////////////////////////USESELECTOR ///////////////////////////////////////////////

  ////////////////////////////////////USESELECTOR ///////////////////////////////////////////////

  ////////////////////////////////////USE EFFECT HOOK ///////////////////////////////////////////////
  useEffect(() => {
    setData(ProfileDetatileState)
  }, [ProfileDetatileState])

  useEffect(() => {
    if (confirm == true) {
      dispatch(
        DeleteStaffAccount({
          userIds: [ProfileDetatileState?._id],
        })
      )
      navigate('/accounts/staff-account')
    }
  }, [confirm])

  ////////////////////////////////////USE EFFECT HOOK ///////////////////////////////////////////////

  ////////////////////////////////////USE MEMO HOOK USE FOR POPUP  ///////////////////////////////////////////////

  const notification = useMemo(
    () => <CreateNotification show={notify} handleClose={() => setNotify(false)} />,
    [notify]
  )
  const ConfirmDelete = useMemo(
    () => (
      <DeleteConfirmationPopup
        Message={'Are you sure you want to Delete this Profile'}
        show={deletePopup}
        confirm={() => setConfirm(true)}
        handleClose={() => setDeletePopup(false)}
      />
    ),
    [deletePopup]
  )

  ////////////////////////////////////USE MEMO HOOK USE FOR POPUP ///////////////////////////////////////////////

  ////////////////////////FUNTIONS FOR DIFFERENT OPERATIONS/////////////////////////////////////

  const handleCombineStatus = (status: string) => {
    dispatch(
      UpdateStatusStaff({
        page: {
          page: 1,
          size: 10,
          search: '',
          industry: '',
          status: '',
          accountId: '',
        },
        data: {
          userId: data?._id,
          status2: status,
        },
      })
    )
  }

  const handleLoginStaff = () => {
    dispatch(resetRedux())
    let data = {
      email: ProfileDetatileState.email,
      userid: ProfileDetatileState._id,
    }
    dispatch(adminLoginAsStaff(data)).then((res: any) => {
      if (!!res?.error && !res?.payload) {
        navigate('/auth/admin')
      }
    })
  }

  const openQuickMessage = useMemo(
    () => (
      <QuickMessageDrawerInner
        handleClose={() => setQuickMessagePopup(false)}
        show={quickMessagePopup}
        contacts={[{value: ProfileDetatileState?.mobile, label: ProfileDetatileState?.mobile}]}
        //  valid={valid} setValid={setValid} virtualNumber={virtualNumber}
      />
    ),
    [quickMessagePopup]
  )

  return (
    <>
      {notification}
      {AuthenticateUser('send-quick-sms') && quickMessagePopup && openQuickMessage}
      {ConfirmDelete}
      <Routes>
        <Route
          element={
            <>
              <div className='row'>
                <StaffProfile />
                <div className='col-md-8'>
                  <div className='d-flex justify-content-between'>
                    <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder'>
                      <li
                        className='nav-item cursor-pointer'
                        onClick={() => navigate('/staff-profile/overview')}
                      >
                        <span
                          className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                            param?.pathname?.split('/').at(-1) == 'overview' && 'active'
                          } `}
                        >
                          Overview
                        </span>
                      </li>

                      <li
                        className='nav-item cursor-pointer'
                        onClick={() => navigate('/staff-profile/credits')}
                      >
                        <span
                          className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                            param?.pathname?.split('/').at(-1) == 'credits' && 'active'
                          } `}
                        >
                          Credits
                        </span>
                      </li>

                      {!isUserWhiteLabel && (
                        <li
                          className='nav-item cursor-pointer'
                          onClick={() => navigate('/staff-profile/assignUser')}
                        >
                          <span
                            className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                              param?.pathname?.split('/').at(-1) == 'assignUser' && 'active'
                            } `}
                          >
                            Assigned User
                          </span>
                        </li>
                      )}

                      {!isUserWhiteLabel && (
                        <li
                          className='nav-item cursor-pointer'
                          onClick={() => navigate('/staff-profile/commision')}
                        >
                          <span
                            className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                              param?.pathname?.split('/').at(-1) == 'commision' && 'active'
                            } `}
                          >
                            Commision
                          </span>
                        </li>
                      )}

                      <li
                        className='nav-item cursor-pointer'
                        onClick={() => navigate('/staff-profile/more')}
                      >
                        <span
                          className={`nav-link text-active-primary ms-0 fw-lighter h-50px pb-0 px-4 pt-0 ${
                            param?.pathname?.split('/').at(-1) == 'more' && 'active'
                          } `}
                        >
                          More
                        </span>
                      </li>
                    </ul>
                    <div className='d-flex my-4'>
                      <div className='me-0'>
                        <button
                          className='btn btn-primary'
                          data-kt-menu-trigger='click'
                          data-kt-menu-placement='bottom-end'
                        >
                          Actions
                          <span className='svg-icon svg-icon-primary svg-icon-2 ms-2 me-0'>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              xmlnsXlink='http://www.w3.org/1999/xlink'
                              width='24px'
                              height='24px'
                              viewBox='0 0 24 24'
                              version='1.1'
                            >
                              <g stroke='none' strokeWidth={1} fill='none' fillRule='evenodd'>
                                <polygon points='0 0 24 0 24 24 0 24' />
                                <path
                                  d='M6.70710678,15.7071068 C6.31658249,16.0976311 5.68341751,16.0976311 5.29289322,15.7071068 C4.90236893,15.3165825 4.90236893,14.6834175 5.29289322,14.2928932 L11.2928932,8.29289322 C11.6714722,7.91431428 12.2810586,7.90106866 12.6757246,8.26284586 L18.6757246,13.7628459 C19.0828436,14.1360383 19.1103465,14.7686056 18.7371541,15.1757246 C18.3639617,15.5828436 17.7313944,15.6103465 17.3242754,15.2371541 L12.0300757,10.3841378 L6.70710678,15.7071068 Z'
                                  fill='#ffffff'
                                  fillRule='nonzero'
                                  transform='translate(12.000003, 11.999999) rotate(-180.000000) translate(-12.000003, -11.999999)'
                                />
                              </g>
                            </svg>
                          </span>
                        </button>
                        <div
                          className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-bold w-200px py-3'
                          data-kt-menu='true'
                          style={{}}
                        >
                          <div className='menu-item px-3'>
                            <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
                              Contact
                            </div>
                          </div>
                          <div className='menu-item px-3'>
                            {AuthenticateUser('send-quick-sms') && (
                              <div
                                className='aside-footer flex-column-auto'
                                id='kt_drawer_chat_toggle'
                              >
                                <a
                                  target='_blank'
                                  className='menu-link px-3'
                                  data-bs-toggle='tooltip'
                                  data-bs-trigger='hover'
                                  data-bs-dismiss-='click'
                                  title='Check out the complete documentation with over 100 components'
                                  onClick={() => setQuickMessagePopup(true)}
                                >
                                  Send quick message
                                </a>
                                {/* <a href="#" className="menu-link px-3">Send quick message</a> */}
                              </div>
                            )}
                          </div>
                          <div className='menu-item px-3'>
                            <a
                              href={`mailto:${ProfileDetatileState?.email}`}
                              className='menu-link px-3'
                            >
                              Send email
                            </a>
                          </div>
                          <div className='menu-item px-3'>
                            <span onClick={() => setNotify(true)} className='menu-link px-3'>
                              Add portal notification
                            </span>
                          </div>
                          <div className='menu-item px-3'>
                            <span onClick={handleLoginStaff} className='menu-link px-3'>
                              Login as staff
                            </span>
                          </div>
                          <div className='separator my-2' />
                          <div className='menu-item px-3'>
                            <div className='menu-content text-muted pb-2 px-3 fs-7 text-uppercase'>
                              Account
                            </div>
                          </div>
                          <div
                            className='menu-item px-3'
                            data-kt-menu-trigger='hover'
                            data-kt-menu-placement='right-end'
                          >
                            <span className='menu-link'>
                              <span className='menu-title'>Status</span>
                              <span className='menu-arrow' />
                            </span>
                            <div className='menu-sub menu-sub-dropdown w-175px py-4'>
                              <div
                                className='menu-item px-3'
                                onClick={() => handleCombineStatus('active')}
                              >
                                <span className='menu-link px-3'>
                                  <span className='bg-success   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                  <span className='menu-title'>Active</span>
                                  {data?.status2 == 'active' && (
                                    <span className='svg-icon svg-icon-primary'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        xmlnsXlink='http://www.w3.org/1999/xlink'
                                        width='24px'
                                        height='24px'
                                        viewBox='0 0 24 24'
                                        version='1.1'
                                      >
                                        <g
                                          stroke='none'
                                          strokeWidth={1}
                                          fill='none'
                                          fillRule='evenodd'
                                        >
                                          <polygon points='0 0 24 0 24 24 0 24' />
                                          <path
                                            d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                            fill='#7950f2'
                                            fillRule='nonzero'
                                            transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  )}
                                </span>
                              </div>
                              <div
                                className='menu-item px-3'
                                onClick={() => handleCombineStatus('inactive')}
                              >
                                <span className='menu-link px-3'>
                                  <span className='bg-secondary   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                  <span className='menu-title'>Inactive</span>

                                  {data?.status2 == 'inactive' && (
                                    <span className='svg-icon svg-icon-primary'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        xmlnsXlink='http://www.w3.org/1999/xlink'
                                        width='24px'
                                        height='24px'
                                        viewBox='0 0 24 24'
                                        version='1.1'
                                      >
                                        <g
                                          stroke='none'
                                          strokeWidth={1}
                                          fill='none'
                                          fillRule='evenodd'
                                        >
                                          <polygon points='0 0 24 0 24 24 0 24' />
                                          <path
                                            d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                            fill='#7950f2'
                                            fillRule='nonzero'
                                            transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  )}
                                </span>
                              </div>
                              <div
                                className='menu-item px-3'
                                onClick={() => handleCombineStatus('suspended')}
                              >
                                <span className='menu-link px-3'>
                                  <span className='bg-danger   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                  <span className='menu-title'>Suspended</span>

                                  {data?.status2 == 'suspended' && (
                                    <span className='svg-icon svg-icon-primary'>
                                      <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        xmlnsXlink='http://www.w3.org/1999/xlink'
                                        width='24px'
                                        height='24px'
                                        viewBox='0 0 24 24'
                                        version='1.1'
                                      >
                                        <g
                                          stroke='none'
                                          strokeWidth={1}
                                          fill='none'
                                          fillRule='evenodd'
                                        >
                                          <polygon points='0 0 24 0 24 24 0 24' />
                                          <path
                                            d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                            fill='#7950f2'
                                            fillRule='nonzero'
                                            transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                          />
                                        </g>
                                      </svg>
                                    </span>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className='menu-item px-3 my-1' onClick={() => setDeletePopup(true)}>
                            <a className='menu-link px-3 text-danger'>Delete client</a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <Outlet />
                </div>
              </div>
            </>
          }
        >
          <Route index element={<Navigate to='/staff-profile/overview' replace={true} />} />

          <Route
            path='overview'
            element={
              <>
                <Overview />
              </>
            }
          />
          <Route
            path='credits'
            element={
              <>
                <Credits />
              </>
            }
          />
          {!isUserWhiteLabel && (
            <Route
              path='assignUser'
              element={
                <>
                  <AssignUser />
                </>
              }
            />
          )}

          {!isUserWhiteLabel && (
            <Route
              path='commision'
              element={
                <>
                  <Commision />
                </>
              }
            />
          )}
          <Route
            path='more'
            element={
              <>
                <More />
              </>
            }
          />
        </Route>
      </Routes>
    </>
  )
}

export default StaffProfileDetails
